import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../models/auth.models';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthmongoService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(credentials: any) {

    // //console.logcredentials)

    let t={
      username: credentials.username,
      password: credentials.password,
    }
    const url = environment.url_uu + 'auth/login';
    return this.http.post<any>(url, t).pipe(
      map((user) => {

        console.log(user);

        // login successful if there's a jwt token in the response
  
        // if (user['t'].role === 'registration' && !user.paper) {
        //   // localStorage.setItem('currentUser', JSON.stringify(user));
        //   // this.currentUserSubject.next(user);
        //   return false;
        // }

        // if (user['t'] && user['t'].token) {
        if (user) {

          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject.next(user);
        }
       
        return user;
      })
    );
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    this.router.navigate(['/account/login']);
    // if (this.modalRef) {
    //   this.modalRef.hide();
    // }
  }
}
